import React from 'react';
import CheckList from '../../../Elements/CheckList';
import CheckListToneEnum from '../../../Enums/CheckListToneEnum';

const items = [
  { tone: CheckListToneEnum.Ok, text: 'No ready job is left out.' },
  { tone: CheckListToneEnum.Info, text: '1 job is out of scope: a person took it off one of the drafts.' },
  {
    tone: CheckListToneEnum.Warn,
    text: '2 jobs cannot be added: their survey is marked neither invoiceable nor uninvoiceable.',
  },
];

function CheckListDemoComponent() {
  return <CheckList items={items} />;
}

export const checkListDemo = {
  id: 'check-list',
  title: 'Check list',
  category: 'Basics',
  importPath: 'Elements/CheckList',
  notes: [
    'Points to look at, one row each, in a bordered list: the icon of the kind of point, then the text.',
    'items are { tone, text }; tone is a CheckListToneEnum value: Ok (green tick), Info (blue i, the default) or Warn (amber triangle). text may be an element.',
    'The icon carries the meaning, so it shows whatever the "I like icons" setting says.',
  ],
  snippet: '<CheckList\n  items={[{ tone: CheckListToneEnum.Ok, text: "No job is left out." }]}\n/>',
  render: CheckListDemoComponent,
};
